<template>
  <div id="inventory-view">
    <v-container
      fluid
    >
      <v-row>
        <v-col>
          <v-data-table
            :headers="headers"
            :items="inventories"
            sort-by="cost"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar
                flat
                color="white"
              >
                <v-toolbar-title>Video Analysis</v-toolbar-title>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                />
                <v-spacer />
                <v-dialog
                  v-model="dialog"
                  max-width="500px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      class="mb-2"
                      v-bind="attrs"
                      v-on="on"
                    >
                      New Item
                    </v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      <span class="text-h5">{{ formTitle }}</span>
                    </v-card-title>

                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                              v-model="editedItem.name"
                              label="Device Name"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-select
                              v-model="editedItem.wearStatus"
                              :items="['In Progress', 'Reviewed', 'Cancelled']"
                              :menu-props="{ top: true, offsetY: true }"
                              label="Status"
                            />
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                              v-model="editedItem.Location"
                              label="Location"
                            />
                          </v-col>
                          <v-col
                            cols="6"
                            sm="6"
                            md="4"
                          >
                            <v-menu
                              ref="menu"
                              v-model="date"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="editedItem.date"
                                  label="Picker in menu"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                />
                              </template>
                              <v-date-picker
                                v-model="editedItem.date"
                                no-title
                                scrollable
                              >
                                <v-spacer />
                                <v-btn
                                  text
                                  color="primary"
                                  @click="menu = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="$refs.menu.save(date)"
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col
                            cols="12"
                            sm="6"
                            md="4"
                          >
                            <v-text-field
                              v-model="editedItem.link"
                              label="Link"
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>

                    <v-card-actions>
                      <v-spacer />
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="close"
                      >
                        Cancel
                      </v-btn>
                      <v-btn
                        color="blue darken-1"
                        text
                        @click="save"
                      >
                        Save
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-toolbar>
            </template>
            <template v-slot:item.status="{ item }">
              <v-chip
                :color="getColor(item.status)"
                dark
              >
                {{
                  item.status
                }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon
                small
                class="mr-2"
                @click="editItem(item)"
              >
                mdi-pencil
              </v-icon>
              <v-icon
                small
                @click="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-btn
                color="primary"
                @click="initialize"
              >
                Reset
              </v-btn>
            </template>
          </v-data-table>
        </v-col>
        <v-col>
          <material-card
            color="primary"
            icon="mdi-school"
          >
            <template #title>
              In-depth Learning
            </template>

            <template>
              <v-container class="fill-height">
                <v-row justify="center">
                  <iframe
                    width="560"
                    height="315"
                    src="https://www.youtube-nocookie.com/embed/pOAREnBay10"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                  />
                </v-row>
              </v-container>
              <v-divider />
              <v-container class="fill-height">
                <v-expansion-panels>
                  <v-expansion-panel>
                    <v-card flat>
                      <v-card-text>
                        <v-expansion-panel-header>
                          <v-row
                            align="center"
                          >
                            <strong class="text-h6">2:25</strong>
                            <v-spacer />
                            <v-btn icon>
                              <v-icon>mdi-account</v-icon>
                            </v-btn>
                          </v-row>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <p>
                            Yikes. Look at how the Champion rams through the defense right there. Do you think we can pull that off?
                          </p>
                        </v-expansion-panel-content>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-card flat>
                      <v-card-text>
                        <v-expansion-panel-header>
                          <v-row
                            class="mb-4"
                            align="center"
                          >
                            <strong class="text-h6">2:35</strong>
                            <v-spacer />
                            <v-btn icon>
                              <v-icon>mdi-account</v-icon>
                            </v-btn>
                          </v-row>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <p>
                            Wonder why Faker made a move at this time? Was this just dumb luck?
                          </p>
                        </v-expansion-panel-content>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-card flat>
                      <v-card-text>
                        <v-expansion-panel-header>
                          <v-row
                            class="mb-4"
                            align="center"
                          >
                            <strong class="text-h6">2:44</strong>
                            <v-spacer />
                            <v-btn icon>
                              <v-icon>mdi-account</v-icon>
                            </v-btn>
                          </v-row>
                        </v-expansion-panel-header>

                        <v-expansion-panel-content>
                          <p>
                            Look at their defense. It really is amazing.
                          </p>
                        </v-expansion-panel-content>
                      </v-card-text>
                    </v-card>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-container>
            </template>
          </material-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: 'InventoryView',

    data: () => ({
      dialog: false,
      headers: [
        {
          text: 'Game Name',
          align: 'start',
          sortable: false,
          value: 'name',
        },
        { text: 'Status', value: 'status' },
        { text: 'Location', value: 'location' },
        { text: 'Date', value: 'date' },
        { text: 'Link', value: 'link', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      inventories: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        status: 'In Progress',
        location: '',
      },
      defaultItem: {
        name: '',
        status: 'In Progress',
        location: '',
      },
    }),

    computed: {
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      },
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.inventories = [
          {
            name: 'ESporter Championship',
            status: 'In Progress',
            location: 'New York',
            date: new Date().toISOString().substr(0, 10),
          },
          {
            name: 'Vs. Wolves',
            status: 'Reviewed',
            location: 'Twitch',
            date: '2020-03-12',
          },
          {
            name: 'KeSPA SemiF',
            status: 'In Progress',
            location: 'Ulsan',
            date: '2021-01-21',
          },
          {
            name: 'Practice Round',
            status: 'Cancelled',
            location: 'Youtube Gaming',
            date: '2021-04-02',
          },
          {
            name: 'vs. Witches',
            status: 'In Progress',
            location: 'Twitch',
            date: new Date().toISOString().substr(0, 10),
          },
        ]
      },

      editItem (item) {
        this.editedIndex = this.inventories.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem (item) {
        const index = this.inventories.indexOf(item)
        confirm('Are you sure you want to delete this item?') &&
          this.inventories.splice(index, 1)
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.inventories[this.editedIndex], this.editedItem)
        } else {
          this.inventories.push(this.editedItem)
        }
        this.close()
      },

      getColor (wearStatus) {
        if (wearStatus === 'Cancelled') return 'red'
        else if (wearStatus === 'In Progress') return 'orange'
        else return 'green'
      },
      formatPrice (value) {
        const val = (value / 1).toFixed(2).replace('.', ',')
        return '$' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      },
    },
  }
</script>
